import React, { useEffect } from 'react';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, BillingActionCreators, IApplicationState, IOpoAddResponse, IOpoAddUpdateRequest, IValidateAchRoutingNumberResponse, OpoActionCreators } from '@nkr/store/index';
import { IOptnRegion, IState } from '@nkr/models/index';
import { Alert, Button, Modal } from 'react-bootstrap'
import { IAddEditState, initialState } from './add-edit-state';
import { FormProvider, useForm } from 'react-hook-form';
import { AddEditFormWrapper } from '../list/styles';
import usePrevious from '@nkr/services/use-previous';
import OpoContent from './content';

interface IProps {
    show: boolean,
    stateList: IState[],
    optnRegionList: IOptnRegion[],
    onSaveComplete: (id: number, nkrAlias: string, optnAlias: string, name: string, city: string, state: string, isActive: boolean, achApproved: boolean) => void,
    onCancel: () => void
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    add: (request: IOpoAddUpdateRequest) => Promise<IOpoAddResponse>,
    validateAchRoutingNumber: (achRoutingNumber: string) => Promise<IValidateAchRoutingNumberResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const Add = (props: TProps) => {
    const methods = useForm<IAddEditState>({ defaultValues: initialState, mode: 'onSubmit' });
    const { handleSubmit, reset, watch, formState: { isValid, isSubmitted } } = methods;

    const formData = watch();

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            reset(initialState);
        }
    }, [props.show]);

    const handleSave = () => {
        props.showLoading('Saving OPO information, one moment please...').then(() => {
            props.add(formData)
                .then(response => {
                    if (response.data.success) {
                        let { nkrAlias, optnAlias, optnName, nkrName, city, stateId, isActive, achApproved } = formData;

                        let state = props.stateList.find(x=>x.id == stateId);

                        props.onSaveComplete(response.data.results, nkrAlias, optnAlias, optnName || nkrName, city, state.abbreviation, isActive, achApproved);
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    return (
        <Modal backdrop='static' bsSize='lg' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Create New OPO</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isSubmitted && !isValid && (
                    <Alert bsStyle='danger' bsSize='sm'>The items in red are required to continue...</Alert>
                )}

                <FormProvider {...methods}>
                    <AddEditFormWrapper horizontal onSubmit={handleSubmit(handleSave)}>
                        <OpoContent
                            isOpo={false}
                            stateList={props.stateList}
                            optnRegionList={props.optnRegionList}
                            validateAchRoutingNumber={props.validateAchRoutingNumber}
                        />
                    </AddEditFormWrapper>
                </FormProvider>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit(handleSave)}>Add OPO</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        add: (request) => {
            return dispatch(OpoActionCreators.add(request));
        },
        validateAchRoutingNumber: (achRoutingNumber) => {
            return dispatch(BillingActionCreators.validateAchRoutingNumber(achRoutingNumber));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(Add);